// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: xmtlGTX1K1

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import ChecklistItem from "../../ChecklistItem"; // plasmic-import: 4vRjyz8vv6/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicChecklist.module.css"; // plasmic-import: xmtlGTX1K1/css

createPlasmicElementProxy;

export type PlasmicChecklist__VariantMembers = {
  hidden: "hidden";
};
export type PlasmicChecklist__VariantsArgs = {
  hidden?: SingleBooleanChoiceArg<"hidden">;
};
type VariantPropType = keyof PlasmicChecklist__VariantsArgs;
export const PlasmicChecklist__VariantProps = new Array<VariantPropType>(
  "hidden"
);

export type PlasmicChecklist__ArgsType = {};
type ArgPropType = keyof PlasmicChecklist__ArgsType;
export const PlasmicChecklist__ArgProps = new Array<ArgPropType>();

export type PlasmicChecklist__OverridesType = {
  root?: p.Flex<"div">;
  checklistContainer?: p.Flex<"div">;
  text?: p.Flex<"div">;
  hideChecklist?: p.Flex<"div">;
};

export interface DefaultChecklistProps {
  hidden?: SingleBooleanChoiceArg<"hidden">;
  className?: string;
}

const $$ = {};

function PlasmicChecklist__RenderFunc(props: {
  variants: PlasmicChecklist__VariantsArgs;
  args: PlasmicChecklist__ArgsType;
  overrides: PlasmicChecklist__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hidden",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hidden
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          )
        }
      )}
    >
      {(hasVariant($state, "hidden", "hidden") ? true : false) ? (
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__ozTx6,
            {
              [sty.texthidden__ozTx6Qp7I8]: hasVariant(
                $state,
                "hidden",
                "hidden"
              )
            }
          )}
        >
          {hasVariant($state, "hidden", "hidden")
            ? "show Checklist"
            : "hide Checklist"}
        </div>
      ) : null}
      {(hasVariant($state, "hidden", "hidden") ? false : true) ? (
        <p.Stack
          as={"div"}
          data-plasmic-name={"checklistContainer"}
          data-plasmic-override={overrides.checklistContainer}
          hasGap={true}
          className={classNames(projectcss.all, sty.checklistContainer, {
            [sty.checklistContainerhidden]: hasVariant(
              $state,
              "hidden",
              "hidden"
            )
          })}
        >
          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem__ren)}
            done={true}
            text={
              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text
                )}
              >
                {"Quick Tour"}
              </div>
            }
          />

          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem__obD0)}
            text={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__vgjst
                )}
              >
                <React.Fragment>
                  <React.Fragment>{"create a new "}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontStyle: "italic" }}
                  >
                    {"Section"}
                  </span>
                </React.Fragment>
              </div>
            }
          />

          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem___5Gdgg)}
            hideButton={true}
            text={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__q9XwH
                )}
              >
                <React.Fragment>
                  <React.Fragment>{"open "}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontWeight: 700 }}
                  >
                    {"SeeAll"}
                  </span>
                  <React.Fragment>{" on a "}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontStyle: "italic" }}
                  >
                    {"Section"}
                  </span>
                </React.Fragment>
              </div>
            }
          />

          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem__koZxn)}
            text={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__jTvX
                )}
              >
                <React.Fragment>
                  <React.Fragment>{"create a new "}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontStyle: "italic" }}
                  >
                    {"Hub"}
                  </span>
                </React.Fragment>
              </div>
            }
          />

          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem__xivwn)}
            hideButton={true}
            text={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___2TFp6
                )}
              >
                <React.Fragment>
                  <React.Fragment>{"use"}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontStyle: "italic" }}
                  >
                    {" Save for Later"}
                  </span>
                </React.Fragment>
              </div>
            }
          />

          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem__vsBxM)}
            text={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ehwDn
                )}
              >
                {"learn Touch Gestures"}
              </div>
            }
          />

          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem__zt1Gi)}
            text={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__xoFae
                )}
              >
                {"learn Keyboard Shortcuts"}
              </div>
            }
          />

          <ChecklistItem
            className={classNames("__wab_instance", sty.checklistItem___1LLtl)}
            text={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__qQRjV
                )}
              >
                <React.Fragment>
                  <React.Fragment>{"create an "}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontStyle: "italic" }}
                  >
                    {"Account"}
                  </span>
                </React.Fragment>
              </div>
            }
          />

          <div
            data-plasmic-name={"hideChecklist"}
            data-plasmic-override={overrides.hideChecklist}
            className={classNames(projectcss.all, sty.hideChecklist)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__vLlhA,
                {
                  [sty.texthidden__vLlhAqp7I8]: hasVariant(
                    $state,
                    "hidden",
                    "hidden"
                  )
                }
              )}
            >
              {"hide Checklist"}
            </div>
          </div>
        </p.Stack>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "checklistContainer", "text", "hideChecklist"],
  checklistContainer: ["checklistContainer", "text", "hideChecklist"],
  text: ["text"],
  hideChecklist: ["hideChecklist"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  checklistContainer: "div";
  text: "div";
  hideChecklist: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicChecklist__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicChecklist__VariantsArgs;
    args?: PlasmicChecklist__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicChecklist__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicChecklist__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicChecklist__ArgProps,
          internalVariantPropNames: PlasmicChecklist__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicChecklist__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicChecklist";
  } else {
    func.displayName = `PlasmicChecklist.${nodeName}`;
  }
  return func;
}

export const PlasmicChecklist = Object.assign(
  // Top-level PlasmicChecklist renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    checklistContainer: makeNodeComponent("checklistContainer"),
    text: makeNodeComponent("text"),
    hideChecklist: makeNodeComponent("hideChecklist"),

    // Metadata about props expected for PlasmicChecklist
    internalVariantProps: PlasmicChecklist__VariantProps,
    internalArgProps: PlasmicChecklist__ArgProps
  }
);

export default PlasmicChecklist;
/* prettier-ignore-end */
